import { render, staticRenderFns, recyclableRender, components } from "./forget.vue?vue&type=template&id=603e68c0&scoped=true&"
var renderjs
import script from "./forget.vue?vue&type=script&lang=js&"
export * from "./forget.vue?vue&type=script&lang=js&"
import style0 from "./forget.vue?vue&type=style&index=0&id=603e68c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603e68c0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/login/forget/forget.vue"
export default component.exports